module.exports = __webpack_public_path__ + "img/Butterfly_00222.23dc5c3a.png";